import axios from 'axios';
import { getMicroServiceUrl } from '../helpers/helpers';

export const adAnalytics = (data) => {
  return {
    type: 'POST_ANALYTICS',
    payload: axios.post(`${getMicroServiceUrl('aa')}r`, data),
  };
};
